import Immutable from 'seamless-immutable'

const INITIAL_STATE = Immutable({
  user: null,
  loading: true,
})

export default INITIAL_STATE
